import { ModalCookies } from '@lideralia/alife-uikit/dist/organisms/Modals/Cookies';
import React from 'react';

export const CookiesTemplate = (props) => <ModalCookies {...props} />;
